<template>
  <div
    :class="{
      'pool-additional-info-mobile': isMobile,
      'pool-additional-info': !isMobile,
    }"
  >
    <div class="binstep">
      <img class="binstep__img" src="@/assets/bin-step.svg" />
      <span class="binstep__label"
        >Bin step:<b>{{ ` X${pool.binStep}` }}</b>
      </span>
    </div>
    <div class="contract">
      <img class="contract__img" src="@/assets/contract-version.svg" />
      <span class="contract__label">{{ `Ver. ${pool?.contract}` }}</span>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ITablePoolV1 } from '@/types/pools';
import { toRefs } from 'vue';

interface IProps {
  pool: ITablePoolV1;
  isMobile?: boolean;
}
const props = withDefaults(defineProps<IProps>(), {
  isMobile: false,
});
const { pool, isMobile } = toRefs(props);
</script>
<css lang="scss" scoped src="./style.scss" />
